export default __webpack_public_path__ + "static/media/Belt of the Ghost of the Veldt.912db119.jpg";